import { cn } from '@/lib/utils';

import { Text } from '@/components/atoms/Text';

const PricingSectionRowPrimaryText = ({
  text,
  isStatic,
  isHeader,
  shouldCenter,
  hasBadgeOfHonor
}: {
  text: string;
  isStatic: boolean;
  isHeader: boolean;
  shouldCenter: boolean;
  hasBadgeOfHonor?: boolean;
}) => {
  return (
    <Text
      classNames={{
        wrapper: cn(
          hasBadgeOfHonor ? 'text-gray-dark-25' : 'text-gray-950',
          'flex items-center justify-center',
          'absolute inset-0 transition-transform duration-200',
          !isStatic && 'group-hover/column:-translate-y-2',
          isHeader && 'text-h2',
          !isHeader && 'text-left',
          isStatic && !isHeader && !shouldCenter && '-translate-y-2'
        )
      }}
    >
      {text}
    </Text>
  );
};

export default PricingSectionRowPrimaryText;
